import { TransitionDto } from "@repo/api/transition";
import React from "react";
import { useCurrentFrame, AbsoluteFill, useVideoConfig } from "remotion";
import { getCompositionTransitionWrapper } from "./CompositionTransitionBuilder.ts";

type Props = {
  children: React.ReactNode;
  startTransition: TransitionDto | null;
  endTransition: TransitionDto | null;
  durationInFrames: number;
};

export default function CompositionTransitionWrapper({
  children,
  startTransition,
  endTransition,
  durationInFrames,
}: Props) {
  const { fps } = useVideoConfig();
  const currentFrame = useCurrentFrame();

  const startTransitionWrapper = startTransition
    ? (getCompositionTransitionWrapper("START", startTransition.kind) ?? null)
    : null;

  const endTransitionWrapper = endTransition
    ? (getCompositionTransitionWrapper("END", endTransition.kind) ?? null)
    : null;

  const startStyle =
    startTransitionWrapper?.buildWrapperStyle?.({
      transition: startTransition!,
      fps,
      durationInFrames,
      currentFrame,
    }) ?? null;

  const endStyle =
    endTransitionWrapper?.buildWrapperStyle?.({
      transition: endTransition!,
      fps,
      durationInFrames,
      currentFrame,
    }) ?? null;

  const style = startStyle ?? endStyle ?? {};

  return (
    <AbsoluteFill
      style={{
        ...style,
        overflow: "hidden",
      }}
    >
      {children}
      {startTransitionWrapper?.overlayComponent && (
        <startTransitionWrapper.overlayComponent
          transition={startTransition!}
          fps={fps}
          durationInFrames={durationInFrames}
          currentFrame={currentFrame}
        />
      )}
      {endTransitionWrapper?.overlayComponent && (
        <endTransitionWrapper.overlayComponent
          transition={endTransition!}
          fps={fps}
          durationInFrames={durationInFrames}
          currentFrame={currentFrame}
        />
      )}
    </AbsoluteFill>
  );
}
